/* Three-tee selection is local until one deliberate add. Shopify owns final prices. */
(() => {
  'use strict';
  function mount(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slots = root.querySelector('[data-fg-slots]');
    const total = root.querySelector('[data-fg-total]');
    const status = root.querySelector('[data-fg-status]');
    const add = root.querySelector('[data-fg-add]');
    const picks = [];
    let busy = false, uncertain = false;
    const path = root.dataset.root.replace(/\/?$/, '/');
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:root.dataset.currency}).format(value / 100);
    function render() {
      root.querySelector("[data-fg-mobile]").textContent = `${picks.length} of 3 picked · Review selection ↑`;
      slots.replaceChildren();
      for (let index = 0; index < 3; index++) {
        const li = document.createElement('li'), pick = picks[index];
        if (pick) {
          const img = document.createElement('img'); img.src = pick.image; img.alt = ''; li.append(img);
          const text = document.createElement('span'); text.textContent = `${pick.title} · ${pick.size}`; li.append(text);
          const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remove'; remove.setAttribute('aria-label', `Remove pick ${index+1}: ${pick.title}`); remove.disabled = busy || uncertain;
          remove.addEventListener('click', () => { picks.splice(index,1); render(); status.textContent = 'Tee removed. Choose another tee.'; root.querySelector('[data-fg-choose]:not(:disabled)')?.focus(); }); li.append(remove);
        } else { const number = document.createElement('span');number.textContent=String(index+1);li.append(number);const text=document.createElement('span');text.textContent='Your next tee';li.append(text); }
        slots.append(li);
      }
      if (picks.length === 3) {
        const sum = picks.reduce((n,p)=>n+p.price,0), saving = Math.min(...picks.map(p=>p.price));
        total.textContent = `${money(sum-saving)} estimated · save ${money(saving)}`;
      } else total.textContent = `${picks.length} of 3 picked. Choose ${3-picks.length} more.`;
      add.disabled = picks.length !== 3 || busy || uncertain;
      root.querySelectorAll('[data-fg-choose]').forEach(button => { button.disabled = busy || uncertain || picks.length === 3 || !Array.from(button.closest('[data-fg-pick]').querySelector('select').options).some(o=>o.value&&!o.disabled); });
      root.querySelectorAll('select').forEach(select=>{select.disabled=busy||uncertain;});
    }
    root.querySelectorAll('[data-fg-choose]').forEach(button => button.addEventListener('click', () => {
      if (busy || uncertain || picks.length >= 3) return;
      const card = button.closest('[data-fg-pick]'), select = card.querySelector('select'), option = select.selectedOptions[0];
      if (!option?.value || option.disabled) { status.textContent = 'Choose a size for this tee first.'; select.setAttribute('aria-invalid','true'); const error=card.querySelector('[data-fg-error]'); error.textContent='Choose a size first.'; error.hidden=false; select.focus(); return; }
      select.removeAttribute('aria-invalid'); card.querySelector('[data-fg-error]').hidden=true;
      picks.push({id:Number(option.value),price:Number(option.dataset.price),title:card.dataset.title,size:option.textContent.split(' · ')[0],image:card.querySelector('img').currentSrc});
      render(); status.textContent = picks.length === 3 ? 'Your set is ready. Review your picks, then add them to your cart.' : `${picks.length} of 3 tees picked.`;
      if (picks.length === 3) add.focus();
    }));
    add.addEventListener('click', async () => {
      if (picks.length !== 3 || busy || uncertain) return;
      busy = true; render(); add.setAttribute('aria-busy','true'); status.textContent='Adding your three tees…';
      const controller = new AbortController(), timeout = setTimeout(()=>controller.abort(),12000);
      try {
        const response = await fetch(`${path}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',body:JSON.stringify({items:picks.map(p=>({id:p.id,quantity:1}))}),signal:controller.signal});
        if (!response.ok) throw new Error('cart-add');
        const data = await response.json();
        if (!Array.isArray(data.items)) throw new Error('cart-response');
        status.textContent='Tees added. Opening your cart…'; window.location.assign(`${path}cart`);
      } catch {
        uncertain = true; status.textContent='We could not confirm all three tees were added. Use “View your cart” below to check before adding again.';
      } finally {clearTimeout(timeout);busy=false;add.removeAttribute('aria-busy');render();}
    });
    root.querySelector('[data-fg-workspace]').hidden=false; root.querySelector('[data-fg-mobile]').hidden=false; render();
  }
  document.querySelectorAll('[data-fg-bundle]').forEach(mount);
  document.addEventListener('shopify:section:load', event=>event.target.querySelectorAll('[data-fg-bundle]').forEach(mount));
})();
